// https://www.algolia.com/doc/api-reference/widgets/clear-refinements/js#customize-the-ui-with-connectclearrefinements
import { connectClearRefinements } from 'instantsearch.js/es/connectors';

const ANIMATION_DURATION = 400; // ms, match your CSS animation

const renderClearRefinements = (renderOptions, isFirstRender) => {
  const { canRefine, refine, widgetParams } = renderOptions;
  const container = widgetParams.container;

  if (isFirstRender) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ais-ClearRefinements';

    const button = document.createElement('button');
    button.className = 'ais-ClearRefinements-button';

    if (!canRefine) {
      button.classList.add('is-hidden');
    }

    const span = document.createElement('span');
    span.textContent = 'Clear all';

    button.appendChild(span);
    wrapper.appendChild(button);
    container.appendChild(wrapper);

    button.addEventListener('click', () => {
      // Only spin if clearing
      const hideButton = !canRefine;

      if (hideButton) {
        button.classList.add('is-spinning');
        setTimeout(() => {
          button.classList.remove('is-spinning');
          button.classList.add('is-hidden');
        }, ANIMATION_DURATION);
      } else {
        button.classList.remove('is-hidden');
      }
      refine();
    });
  }

  // Update button state and classes
  const button = container.querySelector('.ais-ClearRefinements-button');
  const span = button?.querySelector('span');
  if (button && span) {
    button.disabled = !canRefine;
    if (!canRefine) {
      button.classList.add('ais-ClearRefinements-button--disabled');
      // span.textContent = 'No refinements';
    } else {
      button.classList.remove('ais-ClearRefinements-button--disabled');
      // Remove hidden when enabled
      button.classList.remove('is-hidden');
      // span.textContent = 'Clear all';
    }
  }
};

export default connectClearRefinements(renderClearRefinements);

// Instantiate the custom widget
// search.addWidgets([
//   customClearRefinements({
//     container: document.querySelector('#clear-refinements'),
//   }),
// ]);
